import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 11h5v4h6v-4h5v9h-16v-9","key":"svg-0"}],["path",{"d":"M9 4h6v4h-6l0 -4","key":"svg-1"}]]

/**
 * IconBrandUnsplash
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtdW5zcGxhc2giCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTFoNXY0aDZ2LTRoNXY5aC0xNnYtOSIgLz4KICA8cGF0aCBkPSJNOSA0aDZ2NGgtNmwwIC00IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-unsplash
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandUnsplash = createReactComponent('outline', 'brand-unsplash', 'BrandUnsplash', __iconNode);

export default IconBrandUnsplash;